import axios from "@/libs/api.request";
// 获取列表
export const getCodBankFee = params => {
  return axios.request({
    url: "/finance/CodBankBill/index",
    method: "get",
    params
  });
};

// 获取银行手续费详情
export const getCodBankFeeDetail = params => {
  return axios.request({
    url: `/finance/CodBankBill/detail/${params.id}`,
    method: "get",
    params
  });
};

export const Delete = data => {
  return axios.request({
    url: "/finance/CodBankBill/delete",
    method: "post",
    data
  });
};

